<template>
  <div>
    <vs-tooltip text="Part Setting" position="top">
      <vs-button
        radius
        class="mr-2"
        color="#333f50"
        type="flat"
        icon="settings"
        v-b-modal.PartSetting
      >
      </vs-button>
    </vs-tooltip>
    <b-modal id="PartSetting" centered hide-footer size="xl">
      <template #modal-title>
        <h3>Part Setting - Factor</h3>
      </template>
      <br />
      <vs-divider border-style="solid" color="#C5C3C3">
        <h5>Part Settings</h5></vs-divider
      >
      <br />
      <div class="ml-5">
        <ul class="ml-5">
          <vs-col>
            <vs-row class="ml-5 pl-4">
              Require Unique Part Names&nbsp;
              <vs-checkbox
                v-model="checkBox1"
                class="ml-4"
                style="right: 3px"
              ></vs-checkbox>
              <vs-tooltip
                text="Checking this box will reqiure that any values put into this field are uniqure across the location on that field."
                position="top"
              >
                <vs-icon icon="help" class="mt-1 mr-5" size="15px"></vs-icon
              ></vs-tooltip>
            </vs-row>
            <br />
            <vs-row class="ml-4 pl-4 mt-3">
              &nbsp;&nbsp;&nbsp;Require Unique Part Numbers
              <vs-checkbox v-model="checkBox1" class="ml-4"></vs-checkbox>
              <vs-tooltip
                text="Checking this box will reqiure that any values put into this field are uniqure across the location on that field."
                position="top"
              >
                <vs-icon icon="help" class="mt-1" size="15px"></vs-icon
              ></vs-tooltip>
            </vs-row>
            <br />
            <vs-row class="mt-2">
              <p class="mt-2">Set a description for parts listed in POs</p>
              <vs-button
                color="#32C040"
                icon="add_box"
                style="border-radius: 20px"
                class="ml-3 mb-4"
                ><b>Create Default</b></vs-button
              >
              <vs-tooltip
                text="Adds a default template from parts fields and autp fills the description of parts in purchase orders."
                position="top"
              >
                <vs-icon icon="help" class="ml-2" size="15px"></vs-icon
              ></vs-tooltip>
            </vs-row>
          </vs-col>
        </ul>
      </div>
      <vs-divider border-style="solid" color="#C5C3C3"></vs-divider>
      <div>
        <vs-row>
          <vs-spacer></vs-spacer>

          <vs-button
            color="#32C040"
            style="border-radius: 20px; width: 8%"
            class="ml-2 mr-4"
            @click="$bvModal.hide('PartSetting')"
            ><b>Exit</b></vs-button
          >
        </vs-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>